import { render, staticRenderFns } from "./customerScene.vue?vue&type=template&id=4a355326&scoped=true&"
import script from "./customerScene.vue?vue&type=script&lang=js&"
export * from "./customerScene.vue?vue&type=script&lang=js&"
import style0 from "./customerScene.vue?vue&type=style&index=0&id=4a355326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a355326",
  null
  
)

export default component.exports